module.exports = __webpack_public_path__ + "img/man.b0a8b2d3.jpg";